import { Helmet } from "react-helmet";
import { useState } from "react";
import { useLanguage } from "@/hooks/useLanguage";
import DashboardGrid from "@/components/dashboard/DashboardGrid";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";

export default function Dashboard() {
  const { t } = useLanguage();
  const [timeRange, setTimeRange] = useState(30);

  const timeRanges = [30, 60, 90, 180];

  return (
    <div className="min-h-screen relative overflow-hidden">
      <Helmet>
        <title>{t('dashboard.pageTitle')}</title>
        <meta name="description" content={t('dashboard.description')} />
      </Helmet>
      <Navbar />
      <main className="container mx-auto px-4 py-8 pt-24 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-8 text-center"
        >
          <h1 className="text-4xl font-black tracking-tight sm:text-6xl mb-4 bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-500">
            {t('dashboard.title')}
          </h1>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-6">
            {t('dashboard.subtitle').replace('{days}', timeRange.toString())}
          </p>

          <div className="flex justify-center gap-2 mb-8">
            {timeRanges.map((days) => (
              <Button
                key={days}
                variant={timeRange === days ? "default" : "outline"}
                onClick={() => setTimeRange(days)}
                className="min-w-[80px]"
              >
                {days} {t('days') || 'dni'}
              </Button>
            ))}
          </div>
        </motion.div>

        <DashboardGrid days={timeRange} />
      </main>
      <Footer />
    </div>
  );
}
